import type { CommonOffersType } from '@sravni/ugc/lib/specialOffers/types';

import { getAccumulativeDepositConditions } from '../../helpers/conditions/accumulativeDeposit';
import { getBankrotstvoConditions } from '../../helpers/conditions/bankrotstvo';
import { getBrokerConditions } from '../../helpers/conditions/broker';
import { getCreditConditions } from '../../helpers/conditions/credit';
import { getCreditCardConditions } from '../../helpers/conditions/creditCard';
import { getDebitCardConditions } from '../../helpers/conditions/debitCard';
import { getLoanConditions } from '../../helpers/conditions/loan';
import { getMortgageConditions } from '../../helpers/conditions/mortgage';
import { getSavingsConditions } from '../../helpers/conditions/savings';
import type { OfferTab } from '../../helpers/getProductData';
import { OFFERS_TYPES } from '../products';

export const banksProductsInfo: Record<CommonOffersType, OfferTab> = {
  [OFFERS_TYPES.savings]: {
    key: { type: OFFERS_TYPES.savings },
    label: 'вклад',
    generalLink: '/vklady/',
    linkToOneProduct: 'vklad',
    getConditions: getSavingsConditions,
    advertisingCategory: 'Вклады',
  },
  [OFFERS_TYPES.accumulative]: {
    key: { type: OFFERS_TYPES.accumulative },
    label: 'накопительный счёт',
    generalLink: '/vklady/?accumulativeTypes=accumulative',
    linkToOneProduct: 'vklad',
    getConditions: getAccumulativeDepositConditions,
    advertisingCategory: 'Накопительные счета',
  },
  [OFFERS_TYPES.credits]: {
    key: { type: OFFERS_TYPES.credits },
    label: 'кредит',
    generalLink: '/kredity/',
    linkToOneProduct: 'kredit',
    getConditions: getCreditConditions,
    advertisingCategory: 'Кредиты',
  },
  [OFFERS_TYPES.autocredits]: {
    key: { type: OFFERS_TYPES.autocredits },
    label: 'автокредит',
    generalLink: '/avtokredity/',
    linkToOneProduct: 'avtokredit',
    getConditions: getCreditConditions,
    advertisingCategory: 'Автокредиты',
  },
  [OFFERS_TYPES.mortgage]: {
    key: { type: OFFERS_TYPES.mortgage },
    label: 'ипотека',
    generalLink: '/ipoteka/',
    linkToOneProduct: 'ipoteka',
    getConditions: getMortgageConditions,
    advertisingCategory: 'Ипотека',
  },
  [OFFERS_TYPES.creditCards]: {
    key: { type: OFFERS_TYPES.creditCards },
    label: 'кредитная карта',
    generalLink: '/karty/',
    linkToOneProduct: 'kreditnaja-karta',
    getConditions: getCreditCardConditions,
    advertisingCategory: 'Кредитные карты',
  },
  [OFFERS_TYPES.debitCards]: {
    key: { type: OFFERS_TYPES.debitCards },
    label: 'дебетовая карта',
    generalLink: '/debetovye-karty/',
    linkToOneProduct: 'debetovaja-karta',
    getConditions: getDebitCardConditions,
    advertisingCategory: 'Дебетовые карты',
  },
  [OFFERS_TYPES.loan]: {
    key: { type: OFFERS_TYPES.loan },
    label: 'займ',
    generalLink: '/zaimy/',
    linkToOneProduct: 'mfo',
    getConditions: getLoanConditions,
    advertisingCategory: 'Микрокредиты',
    buttonAction: 'Взять займ',
  },
  [OFFERS_TYPES.brokerskoeObsluzhivanie]: {
    key: { type: OFFERS_TYPES.brokerskoeObsluzhivanie },
    label: '',
    generalLink: '/invest/brokerskoe-obsluzhivanie/',
    linkToOneProduct: '',
    getConditions: getBrokerConditions,
    advertisingCategory: 'Брокерское обслуживание',
  },
  [OFFERS_TYPES.bankrotstvo]: {
    key: { type: OFFERS_TYPES.bankrotstvo },
    label: '',
    generalLink: '/bankrotstvo/',
    linkToOneProduct: '',
    getConditions: getBankrotstvoConditions,
    advertisingCategory: 'Банкротство',
  },
};
